import SearchAdPage from '@/components/google-ads/search/SearchAdPage';
import { LEADS_OBJECTIVE } from './leadsObjective';

/** ADD ADS TO A LEADS AD GROUP — /google-ads/leads/create/ad */
export default function CreateLeadsAd() {
  return <SearchAdPage objective={LEADS_OBJECTIVE} />;
}
